import Api from '@common/services/api';
import { ComponentSettingsPayload, PerformanceFormComponent } from '../types';

export const updateComponent = async (
    organisationId: string,
    formId: string,
    componentId: string,
    payload: ComponentSettingsPayload
  ): Promise<{ data: PerformanceFormComponent }> => {
    const result = await Api.put<{ data: PerformanceFormComponent }>(
      `/v1/organisations/${organisationId}/performance/forms/${formId}/components/${componentId}`,
      payload
    );

    return { data: result.data };
  };
